;(function () {
  window.Ateed.Components.CopyBlock = function() {};
})();
